import axios from "axios";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import * as actions from "../../reducers/review/index";

function loadCommentListAPI(payload) {
  return axios.get(`/api/eh/product-review`, {
    params: { ...payload },
  });
}

function* loadCommentList({ payload }) {
  console.log("payload: ============================== ", payload);

  yield put({
    type: actions.LOADING_REVIEW,
    payload: true,
  });
  try {
    const response = yield call(loadCommentListAPI, payload);
    console.log("response: ", response);
    console.log(
      "response.data.data.productReviewList: ",
      response.data.data.productReviewList
    );

    yield put({
      type: actions.LOAD_REVIEW_LIST_SUCCESS,
      payload: response.data.data.productReviewList,
    });
  } catch (error) {
    console.log("error: ", error);
  }

  yield put({
    type: actions.LOADING_REVIEW,
    payload: false,
  });
}

function* watchLoadCommentList() {
  yield takeEvery(actions.LOAD_REVIEW_LIST, loadCommentList);
}

export default function* reviewSaga() {
  yield all([fork(watchLoadCommentList)]);
}
